import { Box, Typography, TextField, MenuItem, useMediaQuery } from "@mui/material";
import { useState, useEffect } from "react";

/**
 * ミリ秒を時間と分に分割する
 * @param {number} msec - 変換するミリ秒
 * @returns {Object} 時間と分を含むオブジェクト
 * @property {number} hour - 時間（0以上の整数）
 * @property {number} minute - 分（0-59の整数）
 * @example
 * // 5400000ミリ秒（1時間30分）の場合
 * const { hour, minute } = getHourAndMinute(5400000);
 * console.log(hour);   // 1
 * console.log(minute); // 30
 */
function getHourAndMinute(msec) {
    if (msec === undefined || msec === 0) {
        return { hour: 0, minute: 0 };
    }
    
    const hourByMsec = Math.floor(msec / (60 * 60 * 1000));  // 時間
    const minuteByMsec = Math.floor((msec % (60 * 60 * 1000)) / (60 * 1000));  // 分
    return { hourByMsec, minuteByMsec };
}


/**
 * カスタム集計項目のコンポーネント
 *
 * @param {Object} props - コンポーネントのプロップス
 * @param {Object} props.customState - カスタム項目の状態
 * @param {Object} props.kintai_bsc - 勤怠データ
 * @param {Function} props.setKintai_bsc - 勤怠データを更新する関数
 * @param {number} props.msec - ミリ秒
 * @returns {JSX.Element} カスタム項目のコンポーネント
 */
const CustomItemComponent = (props) => {

    const {customState, kintai_bsc, setKintai_bsc, msec} = props;

    const { hourByMsec, minuteByMsec } = getHourAndMinute(msec);
    const [hour, setHour] = useState(hourByMsec || 0);
    const [minute, setMinute] = useState(minuteByMsec || 0);

    useEffect(() => {
        const msec = hour * 60 * 60 * 1000 + minute * 60 * 1000;
        setKintai_bsc({...kintai_bsc, [customState.columnName]: msec});
    }, [hour, minute]);
    
    const hourList = [
        {value:0, label:"00"},
        {value:1, label:"01"},
        {value:2, label:"02"},
        {value:3, label:"03"},
        {value:4, label:"04"},
        {value:5, label:"05"},
        {value:6, label:"06"},
        {value:7, label:"07"},
        {value:8, label:"08"},
    ]

    const minuteList = [
        {value:0, label:"00"},
        {value:15, label:"15"},
        {value:30, label:"30"},
        {value:45, label:"45"},
    ]

    const styles = {
        customItemComponent:{
            margin:'0px 30px 10px 0px',
        },
        customItemLabelArea:{
            textAlign:'center',
        },
        customItemTextFieldArea:{
            height:'30px',
            display:'flex',
            flexDirection:'row',
        },
        customItemLabel:{
            fontSize:'1rem',
        },
        customItemTextField:{
            textAlign:'right',
            '& .MuiOutlinedInput-input': {
                padding: '3px 3px 3px 10px',
            }
        },
        customItemTimeSeparator:{
            height:'30px',
            lineHeight:'30px',
            verticalAlign:'middle',
            padding: '3px 3px 3px 3px',
            display: 'flex',
            alignItems: 'center'
        }
    }

    const isMobile = useMediaQuery('(max-width:600px)');

    const spStyles = {
        customItemComponent:{
            width:'100%',
            marginBottom:'5px',
            display:'flex',
            flexDirection:'row',
            fontSize:'0.8rem',
        },
        customItemLabelArea:{
            width:'80%',
            textAlign:'center',
        },
        customItemLabel:{
            fontSize:'0.9rem',
        },
        customItemTextFieldArea:{
            display:'flex',
            flexDirection:'row',
        },
        customItemTextField:{
            textAlign:'right',
            '& .MuiOutlinedInput-input': {
                fontSize:'0.8rem',
                padding: '3px 3px 3px 10px',
            }
        },
        customItemTimeSeparator:{
            height:'30px',
            lineHeight:'30px',
            verticalAlign:'middle',
            padding: '3px 3px 3px 3px',
        }
    }

    return (
        <>
        {(!kintai_bsc || customState.isHidden)?<></>:
            <Box component="div" sx={isMobile?spStyles.customItemComponent:styles.customItemComponent}>
                <Box sx={isMobile?spStyles.customItemLabelArea:styles.customItemLabelArea}>
                    <Typography sx={isMobile?spStyles.customItemLabel:styles.customItemLabel}>{customState.name}</Typography>
                </Box>
                <Box sx={isMobile?spStyles.customItemTextFieldArea:styles.customItemTextFieldArea}>
                    <TextField  
                        variant="outlined" 
                        name="customhour"
                        sx = {isMobile?spStyles.customItemTextField:styles.customItemTextField}
                        style = {isMobile?{width:'70px'}:{width:'70px'}}
                        select
                        value={hour}
                        onChange={(e) => {
                            setHour(e.target.value);
                        }}
                        >
                        {hourList.map((hour, index) => (
                            <MenuItem key={index} value={hour.value}>{hour.label}</MenuItem>
                        ))}
                    </TextField>
                    <Typography style={isMobile?spStyles.customItemTimeSeparator:styles.customItemTimeSeparator}>:</Typography>
                    <TextField 
                        variant="outlined" 
                        name="customminute"
                        sx = {isMobile?spStyles.customItemTextField:styles.customItemTextField}
                        style = {isMobile?{width:'70px'}:{width:'70px'}}
                        select
                        value={minute}
                        onChange={(e) => {
                            setMinute(e.target.value);
                        }}
                        >
                            {minuteList.map((minute, index) => (
                                <MenuItem key={index} value={minute.value}>{minute.label}</MenuItem>
                            ))}
                    </TextField>
                </Box>
            </Box>
        }
        </>
    )
}

export default CustomItemComponent;